import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GoodsInService = {
  async getPurchaseOrderByCode(code) {
    const requestScreenData = {
      url: "api/PurchaseOrderDetail",
      top: "1",
      filter: `PurchaseOrderCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(params) {
    var url = "api/PurchaseOrderDetail";
    return ApiService.createDataSource(url, params);
  },

  async saveGoodsIn(payload) {
    var url = `api/Save_GoodsIn`;
    // var url = `api/Save_PickingSlip`;
    return await ApiService.post(url, payload);
  },

  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "EndDate desc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getGoodsInBatches(filter) {
    const requestScreenData = {
      top: 1,
      url: "api/GoodsInProductBatch",
    };

    if (filter) requestScreenData.filter = filter;

    return await ApiService.oDataGet(requestScreenData);
  },


  async getPurchaseOrderDetail(code) {
    const requestScreenData = {
      url: "api/PurchaseOrderDetail",
      filter: `PurchaseOrderCode eq ${code} and LineStatus eq 'A'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { GoodsInService };
